export default "__VITE_ASSET__65a62da7__"